import { t } from '@lingui/core/macro';
import type { NoddiIconName } from 'noddi-ui-common';
import { NoddiButtonProps, NoddiLink } from 'noddi-ui-web';
import { useBrandCapabilities } from '../../hooks/useBrandCapabilities';
import { useNewBookingPath } from '../../hooks/useNewBookingPath';
import { useClearBookingDrafts } from '../../hooks/useStartNewBooking';

type NewBookingButtonProps = {
  className?: string;
  defaultSize?: boolean;
  variant?: NoddiButtonProps['variant'];
  actionText?: string;
  loading?: boolean;
  hideIcon?: boolean;
  /** Trailing icon; defaults to the forward arrow. */
  endIcon?: NoddiIconName;
  /** Runs after the booking stores are cleared, e.g. to dismiss a menu the button sits in. */
  onClick?: () => void;
};
export const NewBookingButton = ({
  className,
  loading,
  defaultSize,
  variant,
  actionText,
  hideIcon,
  endIcon = 'ArrowRight',
  onClick
}: NewBookingButtonProps) => {
  const clearBookingDrafts = useClearBookingDrafts();
  const { path: newBookingPath } = useNewBookingPath();
  const { canCreateBooking } = useBrandCapabilities();

  function onGoToNewBooking() {
    clearBookingDrafts();
    onClick?.();
  }

  if (!canCreateBooking) {
    return null;
  }

  return (
    <NoddiLink
      className={className}
      variant={variant}
      size={defaultSize ? 'default' : 'small'}
      endIcon={hideIcon ? undefined : endIcon}
      onClick={onGoToNewBooking}
      to={newBookingPath}
      loading={loading}
    >
      {actionText ?? t`New booking`}
    </NoddiLink>
  );
};
